import { Map } from "./components/Map";

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'

import Swup from 'swup';
import SwupA11yPlugin from '@swup/a11y-plugin';
import SwupFragmentPlugin from '@swup/fragment-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupMatomoPlugin from '@swup/matomo-plugin';
import SwupProgressPlugin from '@swup/progress-plugin';

import Gantt from "frappe-gantt";

const Sticky = require('sticky-js');
window.Sticky = Sticky;

window.map = null;
window.mapApp = Map;

const swup = new Swup({ 
    ignoreVisit: (url, { el } = {}) => (el?.matches('[data-no-swup], [href$=".pdf"]')),
    containers: ['#main', '#menu'],
    plugins: [
        new SwupFragmentPlugin({ 
            rules: [
                { 
                    from: ['/spaces'],
                    to: ['/spaces/:space'],
                    containers: ['#space-detail', '#spaces-list'],
                    focus: ['#space-detail'],
                    name: 'space-detail',
                },
                {
                    from: "/spaces/:space",
                    to: "/spaces/:space",
                    containers: ['#space-detail', '#spaces-list', '#menu'],
                    focus: ['#space-detail'],
                    name: 'space-detail',
                },
                {
                    from: "/spaces/:space",
                    to: "/spaces",
                    containers: ['#space-detail', '#spaces-list', '#menu'],
                    focus: ['#main'],
                    name: 'space-detail',
                },
                {
                    from: ['/de/spaces'],
                    to: ['/de/spaces/:space'],
                    containers: ['#space-detail', '#spaces-list'],
                    focus: ['#space-detail'],
                    name: 'space-detail',
                },
                {
                    from: "/de/spaces/:space",
                    to: "/de/spaces/:space",
                    containers: ['#space-detail', '#spaces-list', '#menu'],
                    focus: ['#space-detail'],
                    name: 'space-detail',
                },
                {
                    from: "/de/spaces/:space",
                    to: "/de/spaces",
                    containers: ['#space-detail', '#spaces-list', '#menu'],
                    focus: ['#main'],
                    name: 'space-detail',
                },
            ] 
        }),
        new SwupA11yPlugin({
            announcements: {
              'en': {
                visit: 'Navigated to: {title}',
                url: 'New page at {url}'
              },
              'de': {
                visit: 'Navigiert zu: {title}',
                url: 'Neue Seite unter {url}'
              },
            }
          }
        ),
        new SwupHeadPlugin(),
        new SwupMatomoPlugin(),
        new SwupProgressPlugin(
            {
                className: 'swup-progress-bar',
                transition: 300,
                delay: 300,
                initialValue: 0.25,
                finishAnimation: true
            }              
        ),
    ] 
});

window.swup = swup;

swup.hooks.on('page:view', (visit) => {
    pageVisit();
});

pageVisit();

function pageVisit() {
    initGantt();
    if (window.location.href.includes('/spaces')) {
        let slug = window.location.href.split('/').pop();
        if (slug == 'spaces') {
            if (map != null) return;
            initMap();
        } else {
            if (map != null) return window.map.center(window.map.getMarker(slug).getLatLng());
            initMap(slug);
        }
    } else {
        window.map = null;
        let inlineMapEls = document.querySelectorAll('.inline-map');
        if (!inlineMapEls.length) return;
        inlineMapEls.forEach(el => {
            let dataUrl = el.dataset.url ? el.dataset.url : '/participants.json';
            let inlineMap = new Map(el, dataUrl, null, {
                boxZoom: false,
                doubleClickZoom: false,
                dragging: false,
                keyboard: false,
                scrollWheelZoom: false,
            }, 'cmmgcnu27002901s9gixaemjs')
        });
    }
}

function initMap(space = null) {
    let mapEl = document.querySelector('#map');
    if (!mapEl) return;
    if (!mapEl.classList.contains('is-init')) {
        window.map = new Map(document.querySelector('#map'), '/participants.json', space);
    }
}

function initGantt() {
    let ganttEl = document.querySelector('#gantt');
    if (!ganttEl) return;
    if (!ganttEl.classList.contains('is-init')) {
        let ganttOptions = {
            bar_corner_radius: 0,
            popup: (args => {
                console.log(args);
                window.swup.navigate(args.task.url);
                return false;
            }),
            scroll_to: '2026-05-28',
            date_format: 'YYYY-MM-DD HH:mm',
            snap_at: '1d',
            infinite_padding: false,
            lines: 'vertical',
            // lines: 'none',
            readonly: true,
            column_width: window.innerWidth / 5, // 45
            bar_height: 50, // 35
            today_button: false,
            padding: 10,
            bar_corner_radius: 0,
            view_mode: 'Day',
        }
        fetch('/gantt-exhibitions')
        .then(response => console.log(response) || response)
        .then(response => response.json()) 
        .then(json => {
            window.gantt = new Gantt("#gantt", json, ganttOptions);
            const header = document.querySelector('#gantt .grid-header');
            const gantt = document.querySelector('#gantt');
            const ganttDistanceToTop = gantt.getBoundingClientRect().top;
            window.onscroll = function() {
                const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > ganttDistanceToTop - 25) {
                    header.style.transform = `translateY(${scrollTop - ganttDistanceToTop + 25}px)`;
                } else {
                    header.style.transform = 'translateY(0)';
                }
            }
        });
    }
}

Alpine.plugin(intersect);
Alpine.plugin(focus);
Alpine.start();